import utils from './../utils';
let _webxPinia;
const isLegal = (pinia) => {
    const originFuncs = [
        'createPinia',
        'defineStore',
        'mapState',
        'mapGetters',
        'mapActions',
        'setActivePinia',
        'getActivePinia',
    ];
    return originFuncs.every((func) => pinia?.[func] && typeof pinia?.[func] === 'function');
};
const initPinia = (pinia) => {
    if (!pinia)
        throw new Error('initPinia方法执行错误：initPinia未传入参数，请传入pinia对象');
    if (!isLegal(pinia))
        throw new Error('initPinia方法执行错误：initPinia入参不合法，请传入正确的pinia对象');
    _webxPinia = pinia;
    // 兼容web/server环境重复依赖webx-jssk问题；原生无globalThis
    if (!utils.isUndefined(globalThis))
        globalThis.$__webxPinia = pinia;
};
const checkPinia = (tag = '') => {
    const webxPinia = _webxPinia || globalThis?.$__webxPinia;
    if (!webxPinia)
        throw new Error(`${tag}方法不可用：请先调用initPinia并传入正确的pinia对象`);
    if (!isLegal(webxPinia))
        throw new Error(`${tag}方法不可用：initPinia初始化错误，请传入正确的pinia对象`);
    return webxPinia;
};
const createPinia = () => {
    const webxPinia = checkPinia('createPinia');
    const pinia = webxPinia.createPinia();
    webxPinia.setActivePinia(pinia);
    return pinia;
};
const usePinia = () => {
    const webxPinia = checkPinia('usePinia');
    return webxPinia.getActivePinia();
};
const defineStore = (...args) => {
    const webxPinia = checkPinia('defineStore');
    return webxPinia.defineStore(...args);
};
const mapState = (...args) => {
    const webxPinia = checkPinia('mapState');
    return webxPinia.mapState(...args);
};
const mapGetters = (...args) => {
    const webxPinia = checkPinia('mapGetters');
    return webxPinia.mapGetters(...args);
};
const mapActions = (...args) => {
    const webxPinia = checkPinia('mapActions');
    return webxPinia.mapActions(...args);
};
// @mpxjs/pinia没有PiniaVuePlugin
const PiniaVuePlugin = (...args) => {
    const webxPinia = checkPinia('PiniaVuePlugin');
    if (!webxPinia?.PiniaVuePlugin)
        throw new Error('PiniaVuePlugin方法不可用：initPinia方法传入的pinia对象不支持PiniaVuePlugin方法，请传入正确的pinia对象');
    return webxPinia.PiniaVuePlugin(...args);
};
export { checkPinia, initPinia, createPinia, defineStore, mapState, mapGetters, mapActions, usePinia, PiniaVuePlugin, };
